import api from "@/lib/api";

const HOME = { mentor: "/mentor/dashboard", student: "/dashboard" };

export async function startImpersonation(userId) {
  const { data } = await api.post(`/admin/impersonate/${userId}`);
  const currentToken = localStorage.getItem("weave_token");
  if (currentToken && !localStorage.getItem("weave_token_admin_backup")) {
    localStorage.setItem("weave_token_admin_backup", currentToken);
  }
  localStorage.setItem("weave_token", data.access_token);
  window.location.assign(HOME[data.impersonated_user.role] || "/dashboard");
}
